import { useRouteError } from "react-router-dom";
import { EmptyState } from "../../components/states/emptyState";

export const ErrorBoundary = () => {
  const error = useRouteError();
  console.error("Here's what happened: ", error);

  return (
    <div className="w-full min-h-screen flex flex-col justify-center items-center text-pry-dark-green-300 p-10">
      <EmptyState
        title="Oops! :("
        titleClassName="!normal-case !max-w-[300px] !font-bold"
        subtitle="Something went wrong."
        subtitleClassName="!max-w-[300px] !text-sm"
        actionText="Refresh"
        actionButtonVariant="secondary"
        onClick={() => {
          window.location.reload();
        }}
        image={
          <img
            src="/assets/images/we_got_a_problem.svg"
            alt="We got a problem"
          />
        }
      />
    </div>
  );
};
